import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchImageSlider } from 'redux/image-sliders/actions';

import './ImageSliderDemandSelector.css';

class ImageSliderDemandSelector extends Component {
  static propTypes = {
    patchImageSlider: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
  };

  state = {
    currentValue: 3,
  };

  componentDidMount() {
    this.setState({
      currentValue: this.props.item.slideshow_delay,
    });
  }

  changeValue = value => {
    this.props.patchImageSlider(
      this.props.item.id,
      { slideshow_delay: value },
    );
  };

  onIncrease = () => {
    if (this.state.currentValue === 30) {
      return;
    }

    this.setState({ currentValue: this.state.currentValue + 1 });
    this.changeValue(this.state.currentValue + 1)
  };

  onDecrease = () => {
    if (this.state.currentValue === 1) {
      return;
    }
    this.setState({ currentValue: this.state.currentValue - 1 });
    this.changeValue(this.state.currentValue - 1)
  };

  render() {
    const { currentValue } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="image-slider-demand-selector">
            <div className="wrapper">
              <div className="label">{t("every")}</div>
              <div className="value">{currentValue}</div>
              <div className="controls">
                <div
                  className="control up"
                  onClick={this.onIncrease}
                  role="button"
                  tabIndex={-1}
                />
                <div
                  className="control down"
                  onClick={this.onDecrease}
                  role="button"
                  tabIndex={-1}
                />
              </div>
              <div className="label">{t("seconds")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default connect(
  null,
  {
    patchImageSlider,
  },
)(ImageSliderDemandSelector);
